export default {
    ssl : {
        title : 'SSL电子证书', 
        common : {
            search : '搜索', 
            element : '没有数据，您可以',
            content : '购买SSL证书',
        },
        index : { 
            searchHolder : '请输入搜索内容', 
            gotoBuy : '购买证书',
            FirstColumn  : 'ID',  
            SecondColumn : '订单号',  
            ThirdColumn : '证书',  
            FourthColumn : '绑定域名',  
            FifthColumn : '时效',  
            FifthColumnDesc : '至',  
            SixthColumn : '金额（￥）',
            SeventhColumn : {
                title : '状态',
                Expired : '已过期',
                PendingApplication : '待申请',
                ValidatingApplication : '申请审核中',
                Issued : '已签发',
                Unverified : '未经验证',
                Expiring : '即将过期',
            },
            ActionList : {
                title : '操作',
                Verify : '申请',
                Download : '下载',
                Revoke : '删除',
                Rebuy : '续费',
                View : '查看',
            },
        },
        verifyCertificate : {
            title: '证书申请',
            FirstStep: '填写申请',
            SecondStep: '上传验证材料（可选）',
            FirstColumn  : '绑定域名', 
            FirstPlaceholder  : '仅保护1个域名，如:www.example.com', 
            Required: '此项是必填项',
            SecondColumn : {
                title : '公司类型:',
                FirstLable : '私营个体',
                SecondLable : '商业企业',
                ThirdLable : '政府实体',
                FourthLable : '非盈利组织',
            },
            ThirdColumn : '公司（实体）名称',  
            FourthColumn : '公司电话/邮箱',  
            FifthColumn : "申请人姓名",  
            SixthColumn : "组织部门",  
            SeventhColumn : '申请人邮箱地址',
            EighthColumn : "申请人手机",  
            EighthPlacehloder: "+(国家代码) (地区代码)-(号码)",
            NinthColumn : "所属国家",  
            TenthColumn : "所在省份/州",  
            EleventhColumn : "所在城市",  
            TwelfthColumn : "详细地址",  
            ThirteenthColumn : "邮政编码",  
            FourteenthColumn : "域名验证方式",  
            FifteenthColumn :  {
                title : 'CSR生成方式',
                FirstLable : '系统生成',
                SecondLable : '手动填写',
                FourthLable : 'CSR文件内容',
                placeholder  : '请填写要上传的CSR文件',  
            },
        },
        verifyCertificateSetp2:{
            FirstColumn  : '第一步：您需要下载文件模版，没有模板按钮表示没有模板。',
            SecondColumn : '第二步：打印并填写后，签署姓名。',  
            ThirdColumn : '第三步：选择要上传的扫描文件（仅限PNG/JPG格式，文件大小不超过500KB）。',  
            FourthColumn : '上传营业执照',  
            FirstButton: '关闭',
            SecondButton: '下一步',
            ThirdButton: '上一步',
            FourthButton: '确认',
        },
        view:{
            title : '查看证书', 
            SecondTitle: '基本信息',
            FirstColumn  : '用户名:',  
            SecondColumn : '主域名:',  
            ThirdColumn : '证书类型:',  
            FourthColumn : '颁发厂商:',  
            FifthColumn : '域名保护类型:',  
            SixthColumn : '域名数量:',
            SeventhColumn : {
                title : '状态:',
                Expired : '已过期',
                PendingApplication : '待申请',
                ValidatingApplication : '申请审核中',
                Issued : '已签发',
                Unverified : '未经验证',
                Expiring : '即将过期',
            },
            EighthColumn : "金额:",
            NinthColumn : "时效:",
            ApplicantList : {
                title : '申请人信息', 
                FirstColumn : '营业执照',  
                SecondColumn: '组织部门',
                ThirdColumn: '域名列表',
            },
            viaList:{
                viaDNS: 'DNS验证',
                viaFile: '文件验证',
            },
        },
        error : {
            renewpop:{
                error1 : 'Please enter the login password',
                error2 : 'Please wait for the price calculate out',
                error3 : 'Period must great than 0',
                error4 : 'Please select at least 1 instance',
            },
            startpop:{
                error1 : 'One or more instances can not be start',
            },
            restartpop:{
                error1 : 'One or more instances can not be restart',
            },
            stoppop:{
                error1 : 'One or more instances can not be stop',
            },
            buypop:{
                error1 : 'Please enter the login password',
                error2 : 'Create order fail!',
                error3 : 'Please select payment method!',
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/ssl.js